// Role-based permission helpers
export const ROLES = {
  admin: "Admin",
  finance: "Finance",
  procurement: "Procurement",
  department: "Department User",
  inventory: "Inventory Staff",
};

// admin can do everything
export function can(user, allowed) {
  if (!user) return false;
  if (user.role === "admin") return true;
  if (Array.isArray(allowed)) return allowed.includes(user.role);
  return user.role === allowed;
}

// Which nav items each role sees
export const NAV_VISIBILITY = {
  dashboard: ["admin", "finance", "procurement", "department", "inventory"],
  budgets: ["admin", "finance", "procurement", "department"],
  quotations: ["admin", "finance", "procurement", "department"],
  purchase_orders: ["admin", "finance", "procurement", "department"],
  billing: ["admin", "finance", "procurement", "department"],
  receivables: ["admin", "finance"],
  clients: ["admin", "finance", "procurement", "department"],
  suppliers: ["admin", "finance", "procurement", "department"],
  permits: ["admin", "finance", "procurement", "department"],
  reports: ["admin", "finance", "procurement", "department"],
  client_reports: ["admin", "finance", "procurement"],
  bank_reconciliation: ["admin", "finance"],
  vat_summary: ["admin", "finance"],
  liquidations: ["admin", "finance", "procurement", "department"],
  cash_position: ["admin", "finance"],
  chat: ["admin", "finance", "procurement", "department", "inventory"],
  todos: ["admin", "finance", "procurement", "department", "inventory"],
  inventory: ["admin", "finance", "procurement", "department", "inventory"],
  accountability: ["admin", "finance", "procurement", "department", "inventory"],
  trash: ["admin"],
  users: ["admin"],
  audit_log: ["admin"],
};

export function canSee(user, key) {
  if (!user) return false;
  return NAV_VISIBILITY[key]?.includes(user.role);
}
